var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-modal",
    {
      attrs: { size: "large", closable: false },
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _c("sui-icon", {
        attrs: { name: "close" },
        on: { click: _vm.toggleModal },
      }),
      _c("sui-modal-header", [_vm._v(_vm._s(_vm.modalHeaderText()))]),
      _c(
        "sui-modal-content",
        { attrs: { scrolling: "" } },
        [
          _c("TicketForm", {
            ref: "ticketForm",
            attrs: {
              isNew: _vm.isNew,
              ticket: _vm.ticket,
              toggleModal: _vm.toggleModal,
            },
          }),
        ],
        1
      ),
      _c(
        "sui-modal-actions",
        [
          _c("sui-button", {
            attrs: {
              basic: "",
              type: "button",
              color: "grey",
              size: "small",
              content: "Cancel",
            },
            on: { click: _vm.toggleModal },
          }),
          _c("sui-button", {
            attrs: {
              primary: "",
              type: "button",
              size: "small",
              content: "Save",
            },
            on: { click: _vm.save },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }